import {
  type ConfigurationOperation,
  type GlMapCreateOperation,
  type GlMapHideOperation,
  type GlMapInOut,
  isGlMapCreateOperation,
  isGlMapHideOperation,
} from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'

import type { IndexedOperations, OperationWithSourceInfo } from '../types'

export type GlMapOperation = GlMapCreateOperation | GlMapHideOperation

export const isGlMapOperation = (
  operation: ConfigurationOperation,
): operation is GlMapOperation =>
  isGlMapCreateOperation(operation) || isGlMapHideOperation(operation)

export type IndexedGlMapOperationWithMetaData =
  OperationWithSourceInfo<GlMapOperation>

export type IndexedGlMapOperations = IndexedOperations<GlMapOperation> & {
  mappingId: string
  lastEntity: Optional<GlMapInOut>
}
